import branchdefinitionList from "dummydata/branchdefinitionList";
import { DELETE_BRANCH_DEFINITION } from "redux/actionTypes/actionTypes";
import { ADD_BRANCH_DEFINITION } from "redux/actionTypes/actionTypes";

const initialState = {
  branchdefinitionList: branchdefinitionList,
  invoiceTotal: 0,
};

const branchDefinitionReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_BRANCH_DEFINITION:
      return {
        ...state,
        branchdefinitionList: state.branchdefinitionList.concat(action.payload),
      };
      break;
    case DELETE_BRANCH_DEFINITION:
      return {
        ...state,
        branchdefinitionList: state.branchdefinitionList.filter(
          (item) => !action.payload.includes(item.key)
        ),
      };
      break;
    default:
      break;
  }
  return state;
};
export default branchDefinitionReducer;
